import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
const StoreGetDirections = (props) => {
    const { t } = useTranslation();
    const { store, className, trackingAction } = props;
    return (React.createElement("a", { href: `https://www.google.com/maps/dir/?api=1&destination=${store.latitude},${store.longitude}`, target: "_blank", rel: "noreferrer", className: classNames('get-directions', className), onClick: trackingAction ? trackingAction : undefined },
        React.createElement("span", null, t('button.getdirections'))));
};
export default StoreGetDirections;
